export default __webpack_public_path__ + "static/media/report.ebc26310.svg";